import Vue from 'vue'
import Router from 'vue-router'
// 首页
const index = () => import('@/pages/index/index');
// 期权
const shareOption = () => import('@/pages/shareOption/index');
// 外汇
const foreignTrading = () => import('@/pages/foreignTrading/index');
// 商品交易
const goodsTrading = () => import('@/pages/goodsTrading/index');
// 指数
const exponent = () => import('@/pages/exponent/index');
// 机构账户
const institutions = () => import('@/pages/institutions/index');
// 合作伙伴
const partners = () => import('@/pages/partners/index');
// 新闻
const news = () => import('@/pages/news/index');
// 公司概况
const situation = () => import('@/pages/situation/index');
// 交易平台
const tradingPlatform = () => import('@/pages/tradingPlatform/index');
// 下载
const download = () => import('@/pages/download/index');
// 培训支持
const training = () => import('@/pages/training/index');
// 法律文件
const legalDocument = () => import('@/pages/legalDocument/index');
// 场外交易
const otcTrading = () => import('@/pages/trading/index');
// 订单管理
const otcOrder = () => import('@/pages/order/index');
// 待办订单
const otcBacklogOrder = () => import('@/pages/backlogOrder/index');
// 机构账户
const joinUs = () => import('@/pages/joinUs/index');

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/shareOption',
      name: 'shareOption',
      component: shareOption
    },
    {
      path: '/foreignTrading',
      name: 'foreignTrading',
      component: foreignTrading
    },
    {
      path: '/goodsTrading',
      name: 'goodsTrading',
      component: goodsTrading
    },
    {
      path: '/exponent',
      name: 'exponent',
      component: exponent
    },
    {
      path: '/institutions',
      name: 'institutions',
      component: joinUs
    },
    {
      path: '/partners',
      name: 'partners',
      component: partners
    },
    {
      path: '/news/:label',
      name: 'news',
      component: news
    },
    {
      path: '/situation',
      name: 'situation',
      component: situation
    },
    {
      path: '/tradingPlatform',
      name: 'tradingPlatform',
      component: tradingPlatform
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/training',
      name: 'training',
      component: training
    },
    {
      path: '/legalDocument/:label',
      name: 'legalDocument',
      component: legalDocument
    },
    {
      path: '/otcOrder',
      name: 'otcOrder',
      component: otcOrder
    },
    {
      path: '/otcTrading',
      name: 'otcTrading',
      component: otcTrading
    },
    {
      path: '/otcBacklogOrder',
      name: 'otcBacklogOrder',
      component: otcBacklogOrder
    },
    {
      path: '/joinUs',
      name: 'joinUs',
      component: joinUs
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js